var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8998 18.0998C10.1998 18.0998 8.49978 18.0998 6.79978 18.0998C4.09978 18.0998 1.99978 15.6998 2.49978 12.9998C2.79978 11.4998 3.19978 9.99979 3.59978 8.49979C3.89978 7.69979 4.09978 6.9998 4.39978 6.2998C5.09978 4.5998 6.29978 3.39979 7.89978 2.59979C9.39978 1.79979 11.0998 1.39979 12.7998 1.59979C14.5998 1.79979 16.0998 2.59979 17.4998 3.79979C18.4998 4.69979 19.1998 5.79979 19.5998 7.19979C20.1998 8.99979 20.6998 10.8998 21.2998 12.6998C21.9998 15.2998 20.2998 17.8998 17.5998 18.0998C16.4998 18.1998 15.3998 18.0998 14.2998 18.0998C13.4998 18.0998 12.6998 18.0998 11.8998 18.0998ZM11.9998 16.2998C13.6998 16.2998 15.3998 16.2998 17.0998 16.2998C18.8998 16.2998 20.0998 14.5998 19.5998 12.9998C19.0998 11.4998 18.6998 9.8998 18.1998 8.2998C17.9998 7.6998 17.8998 7.19979 17.5998 6.69979C16.1998 4.09979 13.2998 2.79979 10.4998 3.49979C8.09978 4.09979 6.39978 5.4998 5.69978 7.7998C5.29978 9.0998 4.99978 10.4998 4.69978 11.7998C4.59978 12.3998 4.39978 12.9998 4.29978 13.5998C4.19978 14.9998 5.29978 16.2998 6.79978 16.2998C8.49978 16.2998 10.2998 16.2998 11.9998 16.2998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70054 19.9004H15.6005C15.8005 19.9004 16.0005 20.2004 15.9005 20.4004C15.4005 21.4004 14.0005 22.4004 12.3005 22.5004C10.6005 22.6004 9.00054 21.5004 8.50054 20.4004C8.30054 20.2004 8.40054 19.9004 8.70054 19.9004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.07b9f6939769101f30a6d594cef47c20.svg";
export { ForwardRef as ReactComponent };